import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { type Task } from 'ember-concurrency';
import { or } from 'ember-truth-helpers';
import ecTask from 'garaje/helpers/ec-task';
import isTask from 'garaje/helpers/is-task';

interface TaskButtonSignature {
  Args: {
    task: Task<unknown, unknown[]> | (() => unknown);
    disabled?: boolean;
    text?: string;
    runningText?: string;
  };
  Blocks: {
    default: [isRunning: boolean];
  };
  Element: HTMLButtonElement;
}

export default <template>
  {{#let (if (isTask @task) @task (ecTask @task)) as |task|}}
    <button
      type="button"
      class="btn {{if task.isRunning 'disabled'}}"
      {{on "click" task.perform}}
      disabled={{or task.isRunning @disabled}}
      aria-busy={{task.isRunning}}
      aria-disabled={{task.isRunning}}
      ...attributes
    >
      {{#if (has-block)}}
        {{yield task.isRunning}}
      {{else}}
        {{if task.isRunning @runningText @text}}
      {{/if}}
    </button>
  {{/let}}
</template> satisfies TOC<TaskButtonSignature>;
